export enum InternalUserGender {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  DIVERSE = 'DIVERSE',
}

export interface InternalUserLoginForm {
  readonly emailAddress: string
  readonly password: string
}

export interface InternalUser {
  readonly id: string
  readonly created: Date
  readonly updated: Date
  readonly accessed?: Date
  readonly emailAddress: string
  readonly passwordHash: string
  readonly passwordSalt: string
  readonly locale: LocaleType
  readonly timezone: string
  readonly country: string
  readonly gender: InternalUserGender
  readonly namePrefix?: string
  readonly givenName: string
  readonly familyName: string
}

export default function () {
  const { $api } = useNuxtApp()

  const internalUser = useState<InternalUser | undefined>('internalUser')

  async function internalUserLogin(internalUserLoginForm: InternalUserLoginForm): Promise<boolean> {
    try {
      internalUser.value = await $api('/api/internal-user/_login', {
        method: 'POST',
        body: internalUserLoginForm,
      })
    }
    catch (e) {
      if (e instanceof FetchErrorUnauthorized) {
        return false
      }

      throw e
    }

    return true
  }

  async function internalUserLogout(): Promise<void> {
    await $api('/api/internal-user/_logout', {
      method: 'POST',
    })
    internalUser.value = undefined
  }

  async function updateInternalUserLocale(locale: LocaleType): Promise<void> {
    await $api('/api/internal-user/_update-locale', {
      method: 'POST',
      body: JSON.stringify(locale),
    })

    internalUser.value = { ...internalUser.value!, locale }
  }

  async function getAllInternalUsers(): Promise<InternalUser[]> {
    return cloneObject(await $api('/api/internal-user/_get-all'))
  }

  return {
    internalUser,
    internalUserLogin,
    internalUserLogout,
    updateInternalUserLocale,
    getAllInternalUsers,
  }
}
